import {
    all,
    fork,
    takeEvery,
    call,
    put,
} from 'redux-saga/effects';
import { types, actions } from './reducer';
import { extractError } from '@iso/lib//helpers/api';
import BrandService from '@iso/services/SettingsService/ProductService/BrandService';

function* viewBrand({ id }) {
    try {
        const response = yield call(BrandService.getOne, id);
        yield put(actions.viewBrandSucceeded(response.data));
    } catch (error) {
        yield put(actions.viewBrandFailed(extractError(error)));
    }
}

function* watchViewBrand() {
    yield takeEvery(
        types.REQUEST_VIEW_BRAND,
        viewBrand,
    );
}

function* viewSaga() {
    yield all([
        fork(watchViewBrand),
    ]);
}

export default viewSaga;
